import { Box, IconButton, Tooltip } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import RefreshIcon from "@mui/icons-material/Refresh";
import type { Moment } from "moment";
import { ExcelButton } from "@/controls/buttons/ExcelButton";
import { CrewsFilter } from "@/shared/components/filters/CrewsFilter";

interface Props {
	start: Moment;
	end: Moment;
	onStartChange: (date: Moment | null) => void;
	onEndChange: (date: Moment | null) => void;
	crew: string | null;
	onCrewChange: (crew: string | null) => void;
	onRefresh: () => void;
	onExportExcel: () => void;
	isLoading: boolean;
}

export const KPIShiftReportToolbar = ({
	start,
	end,
	onStartChange,
	onEndChange,
	crew,
	onCrewChange,
	onRefresh,
	onExportExcel,
	isLoading,
}: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="Start"
					format="MM/DD/YYYY"
					value={start}
					maxDate={end}
					onChange={onStartChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="End"
					format="MM/DD/YYYY"
					value={end}
					minDate={start}
					onChange={onEndChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>

			<Box sx={{ width: 130 }}>
				<CrewsFilter value={crew} onChange={onCrewChange} />
			</Box>

			<Tooltip title="Refresh">
				<span>
					<IconButton
						onClick={onRefresh}
						disabled={isLoading}
						size="small"
						sx={{
							bgcolor: "primary.main",
							color: "white",
							width: 28,
							height: 28,
							"&:hover": { bgcolor: "primary.dark" },
							"&.Mui-disabled": {
								bgcolor: "action.disabledBackground",
								color: "action.disabled",
							},
						}}
					>
						<RefreshIcon sx={{ fontSize: 18 }} />
					</IconButton>
				</span>
			</Tooltip>

			<Box sx={{ flexGrow: 1, minWidth: 8 }} />

			<Box sx={{ width: 200 }}>
				<ExcelButton handleExportToExcel={onExportExcel} />
			</Box>
		</Box>
	);
};
